var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('div',{staticClass:"page"},[_c('div',{staticClass:"container px-11 2xl:px-3 my-14 m-auto"},[_c('title-s-chapter',{attrs:{"options":{
                    from: 'from-resolution_blue',
                    to: 'to-dodger_blue',
                }}},[_c('h1',{domProps:{"innerHTML":_vm._s(_vm.currentPage.content.pageTitle.text)}})]),_c('p',{staticClass:"font-bold text-tundora text-xl mb-5",domProps:{"innerHTML":_vm._s(_vm.currentPage.content.pageDescription.text)}}),_c('div',{staticClass:"container-components"},[_c('div',[_c('image-with-descriptions',{staticStyle:{"margin":"0","margin-bottom":"1.25rem"},attrs:{"options":{
                            image300:
                                'pages/' +
                                _vm.currentPage.slug +
                                '/' +
                                _vm.currentPage.images.image1.src,
                            descriptions: [
                                {
                                    text: _vm.currentPage.images.image1.text,
                                    position: 'top-center', // top/bottom-left/right
                                    orientation: 'horizontal-custom-1', // vertical, horizontal
                                    fontSize: 'lg:text-lg -mt-2 lg:-mt-6'
                                },
                                {
                                    text: _vm.currentPage.images.image1.edf,
                                    position: 'top-center', // top/bottom-left/right
                                    orientation: 'horizontal-custom-1', // vertical, horizontal
                                    fontSize: 'mt-10 -mr-8 md:left-8 md:right-20 lg:-mr-12'
                                },
                                {
                                    text: _vm.currentPage.images.image1.alt,
                                    position: 'bottom-right', // top/bottom-left/right
                                    orientation: 'horizontal', // vertical, horizontal
                                } ],
                        }}})],1),_c('div',{staticClass:"card"},[_c('TitleParagraph',{attrs:{"options":{
                            from: 'from-resolution_blue',
                            to: 'to-dodger_blue',
                        }}},[_c('Triangles',{attrs:{"options":{
                                colors: ['#00357f', '#0b4f9c', '#0d94ff'],
                                direction: 'bottom',
                            }}}),_c('span',{domProps:{"innerHTML":_vm._s(_vm.currentPage.content.firstSubTitle.text)}})],1),_c('paragraph',{attrs:{"options":{
                            color: 'text-nandor',
                        }}},[_c('span',{domProps:{"innerHTML":_vm._s(
                                _vm.currentPage.content.secondParagraph.text
                            )}})])],1),_c('div',[_c('image-with-descriptions',{attrs:{"options":{
                            image:
                                'pages/' +
                                _vm.currentPage.slug +
                                '/' +
                                _vm.currentPage.images.image2.src,
                            descriptions: [
                                {
                                    text: _vm.currentPage.images.image2.edf,
                                    position: 'bottom-right', // top/bottom-left/right
                                    orientation: 'horizontal', // vertical, horizontal
                                } ],
                        }}})],1),_c('div',{staticClass:"card",staticStyle:{"padding-top":"0"}},[_c('div',{staticClass:"break-inside-avoid"}),_c('div',{staticClass:"card break-inside-avoid"},[_c('TitleParagraph',{attrs:{"options":{
                            from: 'from-resolution_blue',
                            to: 'to-dodger_blue',
                        }}},[_c('Triangles',{attrs:{"options":{
                                colors: ['#00357f', '#0b4f9c', '#0d94ff'],
                                direction: 'bottom',
                            }}}),_c('span',{domProps:{"innerHTML":_vm._s(_vm.currentPage.content.secondSubTitle.text)}})],1),_c('paragraph',{attrs:{"options":{
                            color: 'text-nandor',
                        }}},[_c('span',{domProps:{"innerHTML":_vm._s(_vm.currentPage.content.thirdParagraph.text)}})]),_c('div',[_c('image-with-descriptions',{staticClass:"eliminate-margin",attrs:{"options":{
                                    image:
                                        'pages/' +
                                        _vm.currentPage.slug +
                                        '/' +
                                        _vm.currentPage.images.image3.src,
                                    descriptions: [
                                        {
                                            text: _vm.currentPage.images.image3
                                                .edf,
                                            position: 'bottom-right', // top/bottom-left/right
                                            orientation: 'horizontal', // vertical, horizontal
                                        } ],
                                }}})],1)],1)]),_c('div',{staticClass:"card"},[_c('div',{staticClass:"break-inside-avoid"},[_c('image-with-descriptions',{attrs:{"options":{
                                    image:
                                        'pages/' +
                                        _vm.currentPage.slug +
                                        '/' +
                                        _vm.currentPage.images.image4.src,
                                    descriptions: [
                                        {
                                            text: _vm.currentPage.images.image4
                                                .edf,
                                            position: 'bottom-right', // top/bottom-left/right
                                            orientation: 'horizontal', // vertical, horizontal
                                        } ],
                                }}}),_c('TitleParagraph',{attrs:{"options":{
                                    from: 'from-resolution_blue',
                                    to: 'to-dodger_blue',
                                }}},[_c('Triangles',{attrs:{"options":{
                                        colors: [
                                            '#00357f',
                                            '#0b4f9c',
                                            '#0d94ff' ],
                                        direction: 'top',
                                    }}}),_c('span',{domProps:{"innerHTML":_vm._s(
                                        _vm.currentPage.content.thirdSubTitle.text
                                    )}})],1),_c('paragraph',{attrs:{"options":{
                                    color: 'text-nandor',
                                }}},[_c('span',{domProps:{"innerHTML":_vm._s(
                                        _vm.currentPage.content.fourthParagraph.text
                                    )}})])],1),_c('div',{staticClass:"relative"},[_c('hotspot-richmedia',{staticClass:"top-2 right-2",attrs:{"options":{
                                icon: 'diaporama',
                                collection: _vm.getRichmediaByCollection(
                                    _vm.currentPage,
                                    "Le projet de téléphérique Dubaï Summit à Hatta"
                                ),
                            }}})],1),_c('div',[_c('image-with-descriptions',{attrs:{"options":{
                                image:
                                    'pages/' +
                                    _vm.currentPage.slug +
                                    '/' +
                                    _vm.currentPage.images.image5.src,
                                descriptions: [
                                    {
                                        text: _vm.currentPage.images.image5
                                            .text,
                                        position: 'top-left', // top/bottom-left/right
                                        orientation: 'horizontal', // vertical, horizontal
                                    },
                                    {
                                        text: _vm.currentPage.images.image5.alt,
                                        position: 'bottom-right', // top/bottom-left/right
                                        orientation: 'horizontal', // vertical, horizontal
                                    } ],
                            }}})],1)]),_c('div',{staticClass:"card"},[_c('TitleParagraph',{attrs:{"options":{
                            from: 'from-resolution_blue',
                            to: 'to-dodger_blue',
                        }}},[_c('Triangles',{attrs:{"options":{
                                colors: ['#00357f', '#0b4f9c', '#0d94ff'],
                                direction: 'top',
                            }}}),_c('span',{domProps:{"innerHTML":_vm._s(_vm.currentPage.content.fourthSubTitle.text)}})],1),_c('paragraph',{attrs:{"options":{
                            color: 'text-nandor',
                        }}},[_c('span',{domProps:{"innerHTML":_vm._s(_vm.currentPage.content.fifthParagraph.text)}})])],1)])],1)])])}
var staticRenderFns = []

export { render, staticRenderFns }